import React from "react";

function ETHeader() {
    return(
            <h3>Expense Tracker</h3>
    )
}
export default ETHeader;